module.exports = __webpack_public_path__ + "static/media/approve-white.8b73b97e.svg";